/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbFormateurDesideratumGridDto } from './FcbFormateurDesideratumGridDto';
import {
    FcbFormateurDesideratumGridDtoFromJSON,
    FcbFormateurDesideratumGridDtoFromJSONTyped,
    FcbFormateurDesideratumGridDtoToJSON,
} from './FcbFormateurDesideratumGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbFormateurDesideratumGridDtoPaginatedResults
 */
export interface FcbFormateurDesideratumGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbFormateurDesideratumGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbFormateurDesideratumGridDto>}
     * @memberof FcbFormateurDesideratumGridDtoPaginatedResults
     */
    results?: Array<FcbFormateurDesideratumGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbFormateurDesideratumGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbFormateurDesideratumGridDtoPaginatedResults interface.
 */
export function instanceOfFcbFormateurDesideratumGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbFormateurDesideratumGridDtoPaginatedResultsFromJSON(json: any): FcbFormateurDesideratumGridDtoPaginatedResults {
    return FcbFormateurDesideratumGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbFormateurDesideratumGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbFormateurDesideratumGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbFormateurDesideratumGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbFormateurDesideratumGridDtoPaginatedResultsToJSON(value?: FcbFormateurDesideratumGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbFormateurDesideratumGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

